import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Flex } from 'onefaceui-react-components';
import { v4 as uuid } from 'uuid';

import { getResourceTo } from 'react/utils/utils';

const commonFlexProps = {
  justifyContent: 'space-between',
  alignItems: 'center',
  className: 'timeWindow-item'
};

function TimeWindows({ stop }) {
  const formatOpenCloseTime = (twOpen, twClose) => (twOpen && twClose && `${twOpen} - ${twClose}`);

  const renderHour = (hours) => {
    const actualTimeWindowOpen = stop.get('actualTimeWindowOpen');
    const actualTimeWindowClose = stop.get('actualTimeWindowClose');
    const actualTimeWindow = formatOpenCloseTime(actualTimeWindowOpen, actualTimeWindowClose);
    return hours.reduce((acc, curr, i) => {
      if (curr) {
        acc.push(
          <span key={uuid()}>
            {acc.length > 0 && <span> | </span>}

            <span
              style={{
                ...(curr === actualTimeWindow && { fontWeight: 'bold' })
              }}
            >
              {curr}
            </span>
          </span>
        );
      }
      return acc;
    }, []);
  };

  const renderDays = (tw) => {
    const actualTimeWindowDay = stop.get('actualTimeWindowDay', '');
    const dayKeys = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const days = tw.delete('timeWindow', Map({}));

    return dayKeys.reduce((acc, curr, i) => {
      const isToRenderComma = acc.length > 0;
      if (days.get(curr)) {
        acc.push(
          <span key={curr}>
            {isToRenderComma && <span>, </span>}
            <span
              style={{
                ...(
                  actualTimeWindowDay.toLowerCase() === curr && { fontWeight: 'bold' }
                )
              }}
            >
              {Monet.I18n.getResourcesByKey(`Greenmile.Data.WeekDays.${curr.substr(0, 3)}`)}
            </span>
          </span>
        );
      }
      return acc;
    }, []);
  };

  const renderTimeWindow = (tw, i) => {
    const emptyValue = '--:--';
    const openTime = tw.getIn(['timeWindow', 'openTime']);
    const closeTime = tw.getIn(['timeWindow', 'closeTime']);
    const tw1Open = tw.getIn(['timeWindow', 'tw1Open']);
    const tw1Close = tw.getIn(['timeWindow', 'tw1Close']);
    const tw2Open = tw.getIn(['timeWindow', 'tw2Open']);
    const tw2Close = tw.getIn(['timeWindow', 'tw2Close']);
    const tw1 = formatOpenCloseTime(tw1Open, tw1Close);
    const tw2 = formatOpenCloseTime(tw2Open, tw2Close);
    const hoursArr = [];
    if (tw1) {
      hoursArr.push(tw1);
    }
    if (tw2) {
      hoursArr.push(tw2);
    }
    const hours = renderHour(hoursArr);
    const openCloseTime = `${openTime || emptyValue} - ${closeTime || emptyValue}`;
    const days = renderDays(tw);

    return (
      <React.Fragment key={uuid()}>
        <Flex {...commonFlexProps}>
          <div>{getResourceTo('Stop.popup.tw.serviceDays')}</div>
          <div>
            {days && (
              <>
                (
                { days }
                )
              </>
            )}
          </div>
        </Flex>
        <Flex {...commonFlexProps}>
          <div>{getResourceTo('Stop.popup.tw.openClose')}</div>
          <div>{openCloseTime}</div>
        </Flex>
        <Flex {...commonFlexProps}>
          <div>{getResourceTo('Stop.popup.tw.timeWindows')}</div>
          <div>{hours}</div>
        </Flex>
      </React.Fragment>
    );
  };

  const timeWindows = useMemo(() => stop.getIn(['location', 'timeWindows'], Map([])), [stop]);

  const children = useMemo(() => timeWindows.map((tw, i) => renderTimeWindow(tw, i)), [timeWindows]);

  return (
    children
  );
}

TimeWindows.propTypes = {
  stop: PropTypes.object.isRequired
};

export default TimeWindows;
